/* Hendy Amsterdam — toestelgeheugen
   Onthoudt het gekozen iPhone-model en houdt de hele site in sync:
   header-chip, collectiekaarten, productpagina-variant en pasvormbevestiging.

   Data-attributen die je overal in het theme kunt gebruiken:
     [data-hendy-device-chip]        krijgt .is-set zodra er een model is
     [data-hendy-device-label]       tekst wordt de modelnaam (fallback = attribuutwaarde)
     [data-hendy-device-fit]         zichtbaar zodra er een model is
     [data-hendy-device-fit-name]    krijgt de modelnaam
     [data-hendy-device-clear]       wist de keuze
     [data-hendy-device-option="iPhone 15 Pro" data-hendy-device-url="/collections/..."]
                                     zet het model (optioneel data-hendy-device-go="true")
     [data-hendy-device-capture="iPhone 15 Pro" data-hendy-device-capture-url="..."]
                                     slaat het model automatisch op bij het laden
*/
(function () {
  'use strict';
  if (window.HendyDevice) { window.HendyDevice.repaint(); return; }
  var KEY = 'hendy_device_v1';

  function read() {
    try { return JSON.parse(window.localStorage.getItem(KEY)); } catch (e) { return null; }
  }
  function write(d) {
    try { window.localStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {}
  }
  function each(sel, fn, root) {
    Array.prototype.forEach.call((root || document).querySelectorAll(sel), fn);
  }

  /* Normaliseren zodat "iPhone 15 Pro", "15 Pro" en "iphone15pro" matchen.
     Let op: exacte gelijkheid, zodat "15 Pro" nooit "15 Pro Max" pakt. */
  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/iphone/g, '')
      .replace(/\(.*?\)/g, '')
      .replace(/[^a-z0-9]+/g, '');
  }

  /* ---------- weergave ---------- */
  function paint() {
    var d = read();

    each('[data-hendy-device-label]', function (el) {
      el.textContent = d ? d.title : (el.getAttribute('data-hendy-device-label') || 'Kies je toestel');
    });
    each('[data-hendy-device-chip]', function (el) {
      el.classList.toggle('is-set', !!d);
      if (d && el.tagName === 'A' && d.url) el.setAttribute('href', d.url);
    });
    each('[data-hendy-device-fit]', function (el) {
      el.hidden = !d;
      var name = el.querySelector('[data-hendy-device-fit-name]');
      if (name && d) name.textContent = d.title;
    });
    each('[data-hendy-device-option]', function (el) {
      el.setAttribute('aria-pressed', String(!!d && el.getAttribute('data-hendy-device-option') === d.title));
    });
    each('[data-hendy-device-clear]', function (el) { el.hidden = !d; });

    syncProduct();
  }

  /* ---------- productpagina ---------- */
  /* Zoekt de radio's of select van de model-optie en zet de juiste aan.
     Dawn regelt daarna zelf prijs, voorraad, afbeelding en URL. */
  function selectVariantOption(optionName, value) {
    var safe = optionName.replace(/"/g, '');
    var radios = document.querySelectorAll('input[type="radio"][name^="' + safe + '"]');
    var i, k;
    for (i = 0; i < radios.length; i++) {
      if (norm(radios[i].value) === norm(value)) {
        if (!radios[i].checked) {
          radios[i].checked = true;
          radios[i].dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }
    }
    var selects = document.querySelectorAll('select[name*="' + safe + '"], select[data-hendy-device-select]');
    for (i = 0; i < selects.length; i++) {
      for (k = 0; k < selects[i].options.length; k++) {
        if (norm(selects[i].options[k].value) === norm(value)) {
          if (selects[i].selectedIndex !== k) {
            selects[i].selectedIndex = k;
            selects[i].dispatchEvent(new Event('change', { bubbles: true }));
          }
          return true;
        }
      }
    }
    return false;
  }

  function syncProduct() {
    var box = document.querySelector('[data-hendy-fit]');
    if (!box) return;

    var d = read();
    var optionName = box.getAttribute('data-hendy-option-name') || 'Telefoonmodel';
    var hasOption = box.getAttribute('data-hendy-has-option') === 'true';
    var values = [];
    try { values = JSON.parse(box.getAttribute('data-hendy-values') || '[]'); } catch (e) {}

    var state = 'empty';
    var matched = null;

    if (d) {
      if (hasOption) {
        for (var i = 0; i < values.length; i++) {
          if (norm(values[i].name) === norm(d.title)) { matched = values[i]; break; }
        }
        if (matched && matched.available === false) state = 'soldout';
        else if (matched) state = 'fits';
        else state = 'nofit';
      } else {
        /* Structuur B: model zit niet als optie op dit product.
           We bevestigen niets hard, maar bieden de modelcollectie aan. */
        state = 'link';
      }
    }

    /* toon het juiste blokje — data-state ook op de buitenste box, zodat CSS
       de opmaak per status kan aanpassen (zie hendy-device-fit.liquid). */
    box.setAttribute('data-state', state);
    each('[data-hendy-state]', function (el) {
      el.hidden = el.getAttribute('data-hendy-state') !== state;
    }, box);
    each('[data-hendy-device-fit-name]', function (el) {
      if (d) el.textContent = d.title;
    }, box);

    /* link naar de modelcollectie */
    if (d && d.url) {
      each('[data-hendy-model-link]', function (el) { el.setAttribute('href', d.url); }, box);
    }

    /* variant selecteren */
    if (state === 'fits' || state === 'soldout') {
      selectVariantOption(optionName, matched.name);
    }

    /* Geen gate meer: de koopknop wordt nooit grijs gemaakt omdat er (nog) geen
       toestel is — alleen een écht uitverkochte variant blijft disabled (dat zet
       Liquid zelf via het HTML disabled-attribuut, zie main-product.liquid).
       Klikt iemand toch zonder gekozen toestel, dan onderscheppen we dat apart
       (zie "koopknop zonder toestel" hieronder) i.p.v. de knop te blokkeren. */
  }

  /* ---------- naar de picker scrollen (i.p.v. een modal) ---------- */
  function scrollToPicker() {
    var picker = document.querySelector('.hy-option-device');
    if (!picker) return;
    picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var field = picker.querySelector('input, select');
    if (field) field.focus({ preventScroll: true });
  }

  /* ---------- api ---------- */
  var api = {
    get: read,
    set: function (d) {
      write(d);
      paint();
      document.dispatchEvent(new CustomEvent('hendy:device', { detail: d }));
    },
    clear: function () {
      try { window.localStorage.removeItem(KEY); } catch (e) {}
      paint();
      document.dispatchEvent(new CustomEvent('hendy:device', { detail: null }));
    },
    repaint: paint,
    normalize: norm
  };

  /* ---------- interactie ---------- */
  document.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-hendy-device-option]');
    if (opt) {
      var d = {
        title: opt.getAttribute('data-hendy-device-option'),
        url: opt.getAttribute('data-hendy-device-url') || ''
      };
      api.set(d);
      if (opt.getAttribute('data-hendy-device-go') === 'true' && d.url) window.location.href = d.url;
      return;
    }
    if (e.target.closest('[data-hendy-device-clear]')) {
      e.preventDefault();
      api.clear();
      return;
    }
    /* "wijzigen" / "kies hierboven" in hendy-device-fit.liquid: alleen scrollen
       en focussen, geen modal, geen keuze wegschrijven. */
    if (e.target.closest('[data-hendy-scroll-to-picker]')) {
      e.preventDefault();
      scrollToPicker();
      return;
    }
    /* Koopknop zonder (bevestigd) toestel: geen echte submit, wel meteen naar de
       picker springen zodat iemand eerst kiest. Een écht uitverkochte variant is
       al disabled via het HTML-attribuut en komt hier dus nooit binnen. */
    var buyBtn = e.target.closest('.hendy-product .product-form__submit');
    if (buyBtn && !buyBtn.disabled) {
      var box = document.querySelector('[data-hendy-fit]');
      if (box && box.getAttribute('data-hendy-has-option') === 'true' && !read()) {
        e.preventDefault();
        scrollToPicker();
      }
    }
  });

  /* ---------- productpagina → toestelgeheugen (two-way sync) ---------- */
  document.addEventListener('change', function (e) {
    var field = e.target.closest('.hy-option-device input, .hy-option-device select');
    if (!field) return;
    var value = field.value;
    if (!value) return;
    var current = read();
    if (current && norm(current.title) === norm(value)) return; /* al gelijk, voorkomt een lus */
    api.set({ title: value, url: (current && current.url) || '' });
  });

  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-hendy-device-search]');
    if (!input) return;
    var scope = document.getElementById(input.getAttribute('data-hendy-device-search'));
    if (!scope) return;
    var q = input.value.toLowerCase().trim(), hits = 0;
    each('[data-hendy-device-option]', function (el) {
      var match = el.getAttribute('data-hendy-device-option').toLowerCase().indexOf(q) > -1;
      el.hidden = !match;
      if (match) hits++;
    }, scope);
    each('[data-hendy-device-group]', function (g) {
      g.hidden = g.querySelectorAll('[data-hendy-device-option]:not([hidden])').length === 0;
    }, scope);
    var empty = scope.querySelector('[data-hendy-device-empty]');
    if (empty) empty.hidden = hits > 0;
  });

  /* Automatisch opslaan zodra iemand op een modelcollectie landt */
  function capture() {
    var el = document.querySelector('[data-hendy-device-capture]');
    if (!el) return;
    var title = el.getAttribute('data-hendy-device-capture');
    var cur = read();
    if (cur && cur.title === title) return;
    write({ title: title, url: el.getAttribute('data-hendy-device-capture-url') || '' });
  }

  /* Dawn vervangt de koopsectie bij variantwissel — daarna opnieuw schilderen */
  document.addEventListener('change', function (e) {
    if (e.target.closest('variant-selects, variant-radios, .product-form__input')) {
      setTimeout(syncProduct, 60);
    }
  });
  document.addEventListener('shopify:section:load', paint);

  function boot() { capture(); paint(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.HendyDevice = api;
})();
